import { Fragment, useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DeleteDraftAssetURL,
  editCollectionAssetsURL,
  Changeassetstatus,
  EditAssetDetailsURL,
  ListofCollectionsURL,
  createCollectionURL,
} from '../DAM_API/urls';
import Axios, { header } from 'functions/Axios';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import deleteicon from '../../../assets/V2-images/deleteicon.png';
import addcomponent from '../../../assets/V2-images/addcomponent.svg';
import shareicon from '../../../assets/V2-images/shareicon.png';
import download from '../../../assets/V2-images/download.png';
import copyurlicon from '../../../assets/V2-images/copyurlicon.png';
import renameicon from '../../../assets/V2-images/renameicon.png';
import { Deletemodel } from 'Common/Deletemodel';
import InputC from 'Common/Inputs/index.tsx';
import { ButtonC } from 'Common/Buttons';
import close from '../../../assets/V2-images/close.svg';
import { useDispatch } from 'react-redux';
import {
  SelectedAssetData,
  SetInnerPrevSelected,
  setOpenPopup,
  SetSelctedFoldersData,
} from 'actions/damActions';
import { DAM_SVG } from '../DamAssets';
import CommonSidePortal from 'Common/SidePortal/SidePortal';
import ShareAssetSection from '../Components/Featured/ShareAsset';
import ImageGridSecondVersion from '../Components/ImageGridSecondVersion';
import CommonThreeDotSvg from '../Components/CommonThreeDotSvg';
import MoveToAssetDesign from '../Components/Featured/MoveToAssetDesign';
import AddToCollectionCommonModal from '../Components/Featured/AddToCollection';
import { useSelector } from 'react-redux';
import { useDownloadAssets } from 'context/DownloadAssetsContext';

export function selectRangeByUUID(data, startId, endId, filterId = 'damFileId') {
  const startIndex = data.findIndex((item) => item[filterId] === startId);
  const endIndex = data.findIndex((item) => item[filterId] === endId);

  if (startIndex === -1 || endIndex === -1) return data;
  const min = Math.min(startIndex, endIndex);
  const max = Math.max(startIndex, endIndex);
  const returnable_data = data.map((item, index) => ({
    ...item,
    isSelected: !item?.isSelected ? index >= min && index <= max : item.isSelected,
  }));

  return returnable_data;
}

const chunkArray = (
  array,
  firstPageSize = 16,
  otherPagesSize = 20
) => {
  const chunks = [];
  let index = 0;

  chunks.push(array.slice(index, index + firstPageSize));
  index += firstPageSize;

  while (index < array.length) {
    chunks.push(array.slice(index, index + otherPagesSize));
    index += otherPagesSize;
  }
  return chunks;
};


export const Assitdata = ({
  assets,
  setAssets,
  isCollectionAdded,
  collectionID,
  showRenderActionButton = true,
  collectionName,
  datashow,
  showCopyLing = true,
  showMoveFolder = true,
  show,
  supportWebp,
  showData = true,
  showCollectionAddition = true,
  FromCollection = false,
  DeleteButtonName = 'Delete',
  gridNumber = 5,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showbar, setshowbar] = useState(null);
  const [images, setImages] = useState([]);
  const [prevIndexSelected, setPrevIndexSelected] = useState();
  const [selectedCount, setSelectedCount] = useState(0);
  const [modal, setmodal] = useState(false);
  const [movetoModal, setMovetoModal] = useState(false);
  const [selectedDamFieldId, setSelectedDamFieldId] = useState(null);
  const [AddToCollectionModal, setAddToCollectionModal] = useState(false);
  const [textvalue, settextvalue] = useState();
  const [folderId, setFolderId] = useState();
  const [datapass, setdatapass] = useState();
  const [addcollection, setaddcollection] = useState(false);
  const [sharelink, setsharelink] = useState(false);
  const [responsedLink, setResponsedLink] = useState();
  const [loading, setloading] = useState(false);
  const threedotIconRef = useRef();

  const [datacollection, setDatacollection] = useState();
  const [expiredate, setexpiredate] = useState();
  const [error, setError] = useState({});
  const [assetInfo, setAssetInfo] = useState({});
  const [expitetime, setexpitetime] = useState();
  const [shareshow, setshareshow] = useState(false);
  const [indexdata, setindexdata] = useState();
  const [emails, setEmails] = useState([]);
  const [Authenticated, setAuthenticated] = useState(true);
  const [isExpiration, setIsExpiration] = useState(false);
  const [activeId, setActiveId] = useState();
  const [openCollectionModal, setOpenCollectionModal] = useState(false);
  const { selectedAssets, selectedFolders, indexSelected } = useSelector((state) => state.dam);
  const { startDownload } = useDownloadAssets();

  const dispatch = useDispatch();

  const closeBtn1 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => setAddToCollectionModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const toggleAddToCollection = () => {
    setAddToCollectionModal(!AddToCollectionModal);
  };

  const handleChange = (evt) => {
    const { value } = evt.target;
    settextvalue(value);
  };

  const folderedit = async () => {
    try {
      const formData = new FormData();
      formData.append('damFileId', selectedDamFieldId);
      formData.append('assetName', textvalue);
      folderId && formData.append('folderId', folderId);
      const response = await Axios.post(EditAssetDetailsURL, formData);

      if (response.data.success) {
        toast.success(response?.data?.message); // Moved toast.success here
        datashow && datashow();
        setAddToCollectionModal(false);
      } else {
        // Handle error case
        toast.error(response?.data?.message); // Moved toast.error here
      }
    } catch (error) {
      // Handle error
      toast.error('Edit Failed'); // Moved toast.error here
    } finally {
      setAddToCollectionModal(false);
      setshowbar(false);
    }
  };

  const collectiondataadd = (damFileId) => {
    // const selectedDamFileIds = images
    //   .filter(image => image.isSelected)
    //   .map(images => images.damFileId);
    fetchCollection();

    setdatapass(damFileId);
    setaddcollection(true);
  };

  const fetchCollection = async () => {
    try {
      const response = await Axios.get(ListofCollectionsURL + `?pageNo=${0}&rowSize=20`);
      if (!response.data.errorStatus) {
        setDatacollection(response?.data?.data?.collections);
      } else {
        // Handle error
      }
    } catch (error) {
      // Handle error
    }
  };

  useEffect(() => {
    let Imagedata;
    if (supportWebp) {
      Imagedata = (selectedAssets ? selectedAssets ?? [] : selectedAssets)?.map((value) => {
        return {
          ...value,
          src: (value.thumnnailUrl ?? value?.fileUrl).replace('.png', '.avif'),
          width: value.fileWidth,
          height: value.fileHeight,
          damFileId: value.assetId,
          fileName: value?.assetName,
          assetType: value?.assetType,
          folderId: value?.folderId,
          isSelected: value?.value ?? value?.isSelected ?? false,
        };
      });
    } else {
      Imagedata = (selectedAssets ? selectedAssets ?? [] : selectedAssets)?.map((value) => {
        return {
          ...value,
          src: value.thumnnailUrl ?? value?.fileUrl,
          width: value.fileWidth,
          height: value.fileHeight,
          damFileId: value.assetId,
          fileName: value?.assetName,
          assetType: value?.assetType,
          folderId: value?.folderId,
          isSelected: value?.value ?? value?.isSelected ?? false,
        };
      });
    }
    const section2Map = new Map(images?.map((item) => [item.damFileId, item.isSelected]));
    const updated = Imagedata?.map((item) => ({
      ...item,
      isSelected: section2Map.has(item.damFileId)
        ? section2Map.get(item.damFileId)
        : item.isSelected,
    }));

    setImages(updated);
  }, [selectedAssets, supportWebp]);

  useEffect(() => {
    const shareAsset = async () => {
      if (isCollectionAdded && images.some((image) => image.isSelected)) {
        try {
          const selectedDamFileIds = images
            .filter((image) => image.isSelected)
            .map((image) => image.damFileId);

          const formData = new FormData();
          formData.append('collectionID', collectionID);
          formData.append('damIds_list', selectedDamFileIds);

          const response = await Axios.post(editCollectionAssetsURL, formData);

          if (response.data.success) {
            toast.success(response?.data?.message ?? 'Added Successfully');
            navigate(-1);
          } else {
            console.error('Error sharing asset:', response.data.message);
            toast.error('Added Fail');
          }
        } catch (error) {
          console.error('Error sharing asset:', error);
        }
      }
    };

    shareAsset();
  }, [isCollectionAdded, images, collectionID, navigate]);

  const downloadImages = async (value) => {
    try {
      const selectedDamFileIds = value
        ? [value]
        : images.filter((image) => image.isSelected).map((image) => image.damFileId);



      await startDownload({
        fileId: selectedDamFileIds,
        folderId: [],
      })

    } catch (error) {
      console.error('Error downloading the files:', error);
      toast.error(error?.message);
      // toast.error('Download Failed');
    }
  };

  const Addassits = async () => {
    try {
      const selectedDamFileIds = images
        .filter((image) => image.isSelected)
        .map((image) => image.damFileId);

      const formData = new FormData();
      selectedDamFileIds.forEach((id) => formData.append('damIds_list', id));

      const response = await Axios.post(Changeassetstatus, formData);

      if (response.data.success) {
        toast.success(response?.data?.message ?? 'Added Successfully');
        const remainingImages = images.filter((image) => !image.isSelected);
        setImages(remainingImages);
        setSelectedCount(0);
      } else {
        console.error('Error deleting asset:', response.data.message);
        toast.error('Delete Failed');
      }
    } catch (error) {
      console.error('Error deleting asset:', error);
      toast.error('Delete Failed');
    }
  };

  const shareMultipleAsset = () => {
    // setindexdata(index);
    handleshowdata();
    setsharelink(!sharelink);
    setshowbar(false);
  };
  const renderActionButtons = () => {
    if (selectedCount > 0) {
      if (location.pathname.includes('/draft')) {
        return (
          <div
            className="d-flex align-items-center justify-content-center gap-1 pointer Secondary-Button large-button"
            onClick={Addassits}
          >
            <img src={download} alt="Addassets Icon" />
            <div className="">Add to Assets</div>
          </div>
        );
      } else {
        return (
          <>
            <div
              className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
              onClick={() => {
                setmodal(true);
              }}
            >
              {DAM_SVG.redDeleteIconSvgComponent}
              <div
                className="text-red"
                style={{
                  color: '#BE5454',
                }}
              >
                {DeleteButtonName}({selectedCount})
              </div>
            </div>

            <div
              className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Tertiary-Button large-button"
              onClick={() => downloadImages()}
            >
              {DAM_SVG.inheritDownloadIcons}
              <div
                className=""
                style={{
                  color: '#753CB7',
                }}
              >
                Download({selectedCount})
              </div>
            </div>

            {showCollectionAddition && (
              <div
                className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Secondary-Button large-button"
                onClick={collectiondataadd}
              >
                {DAM_SVG.inheritDownloadIcons}
                <div className="">Add to Collection</div>
              </div>
            )}
            <div
              className="d-flex align-items-center gap-2 justify-content-center gap-1 pointer Primary-Button large-button"
              onClick={shareMultipleAsset}
            >
              {DAM_SVG.shareIconSvgComponent}
              <div className="">Share</div>
            </div>
          </>
        );
      }
    }
    return null;
  };

  const handledelette = async (e) => {
    try {
      setloading(true);
      const formData = new FormData();
      formData.append('damIds_list', selectedDamFieldId);
      const selectedDamFileIds = images
        .filter((image) => image.isSelected)
        .map((image) => image.damFileId);

      const _data = {
        damIds_list: selectedDamFieldId !== null ? [selectedDamFieldId] : selectedDamFileIds,
      };
      setTimeout(() => {
        setmodal(false);
      }, 4000);
      let respone;
      if (showCollectionAddition) {
        respone = await Axios.delete(DeleteDraftAssetURL, {
          data: _data,
        });
      } else {
        const url = location.pathname;
        const lastPart = url.split('/').pop();

        let body = [
          {
            collectionId: lastPart,
            removeCollectionId:
              selectedDamFieldId !== null ? [selectedDamFieldId] : selectedDamFileIds,
          },
        ];
        respone = await Axios.post(createCollectionURL, body, header);
      }

      setloading(false);
      setmodal(false);
      toast.success(respone?.data?.message);
      datashow && datashow();
      datashow && settextvalue('');
    } catch (err) {
      setmodal(false);
      setloading(false);
      console.log(err);
    }
  };

  const deletmodal = () => {
    setmodal(true);
  };

  const Copylink = (damFileId, url) => {
    try {
      if (url) {
        navigator.clipboard
          .writeText(url)
          .then(() => {
            setsharelink(false);
            toast.success('Copied Successfully'); // Moved toast.success here
          })
          .catch((error) => {
            console.error('Failed to copy URL:', error);
            toast.error('Copy Failed'); // Moved toast.error here
          });
        return;
      }
      const selectedItem = assets?.files?.find(
        (item) => item.damFileId && (item.damFileId === damFileId || item.clientId === damFileId),
      );
      if (selectedItem && selectedItem.fileUrl) {
        const fileUrl = selectedItem.fileUrl;

        navigator.clipboard
          .writeText(fileUrl)
          .then(() => {
            setsharelink(false);
            toast.success('Copied Successfully '); // Moved toast.success here
          })
          .catch((error) => {
            console.error('Failed to copy URL:', error);
            toast.error('Copy Failed'); // Moved toast.error here
          });
      } else {
        console.error('Selected item not found or missing fileUrl property.');
      }
      setshowbar(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleshowdata = async (damFileId, index) => {
    setResponsedLink();
    setError({});
    setexpiredate();
    setexpitetime();
    setAssetInfo({});
    setEmails([]);
    setAuthenticated(true);
    setIsExpiration(false);
    setindexdata(index);
    setsharelink(!sharelink);
    setshowbar(false);
    setActiveId();

    // try {
    //   const response = await Axios.get(GetShareUrl + damFileId);
    //   setlinkdata(response?.data?.data);

    //   setEmails(response?.data?.data?.shareEmails);
    //   setAuthenticated(response?.data?.data?.authenticate);
    //   setexpiredate((prevItems) => ({
    //     ...prevItems,
    //     licenseExpiry: moment(response?.data?.data?.expiredOn).format('YYYY-MM-DD'),
    //   }));
    //   setexpitetime((prevItem) => ({
    //     ...prevItem,
    //     timeexpiry: moment(response?.data?.data?.expiredOn, 'HH:mm').format('HH:mm:ss'),
    //   }));
    //   setAssetInfo((prevState) => ({
    //     ...prevState,
    //     deactivatedAsset: response?.data?.data?.authenticate,
    //   }));
    // } catch (error) {
    //   console.error('Error fetching the share URL:', error);
    // }
  };

  const toggle = () => setmodal(!modal);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (threedotIconRef.current && !threedotIconRef.current.contains(event.target)) {
        yourFunction();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const yourFunction = () => {
    setshowbar(null);
  };

  const MoveToCollecction = async () => {
    try {
      const selectedDamFileIds = images
        .filter((image) => image.isSelected)
        .map((image) => image.damFileId);

      let body = [
        {
          collectionId: collectionID,
          collectionName: collectionName,
          damIdsList: selectedDamFileIds,
        },
      ];
      const result = await Axios.post(createCollectionURL, body, header);

      toast.success(result?.data?.message);

      if (result?.data?.success) {
        navigate('/dam/v2/collection');
      }
    } catch (err) {
      console.error(err);
    }
  };
  const paginatedAssets = chunkArray(selectedAssets || []);

  return (
    <Fragment>
      {modal && (
        <Deletemodel
          deletemodal={modal}
          toggledelete={toggle}
          handleDelete={handledelette}
          loading={loading}
          Header={`${DeleteButtonName} Asset`}
          Content={`Are you sure you want to ${DeleteButtonName?.toLowerCase()}?`}
        />
      )}

      {openCollectionModal && (
        <AddToCollectionCommonModal
          openModal={openCollectionModal}
          Data={selectedDamFieldId}
          ToggleModal={() => {
            setOpenCollectionModal(!openCollectionModal);
          }}
        />
      )}

      {movetoModal && (
        <MoveToAssetDesign
          OpenModal={movetoModal}
          ToggleModal={() => {
            setMovetoModal(!movetoModal);
          }}
          Data={selectedDamFieldId}
          HandleAssetMove={() => {
            datashow && datashow();
          }}
        />
      )}
      <Modal isOpen={AddToCollectionModal} toggle={toggleAddToCollection} style={{ width: '50%' }}>
        <ModalHeader toggle={toggleAddToCollection} close={closeBtn1}>
          Rename File
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label=""
            name="textvalue"
            placeholder="Enter name of folder"
            inputvalue={textvalue}
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            color="Secondary"
            size="lg"
            click={() => setAddToCollectionModal(false)}
          />
          <ButtonC text="Save" size="lg" click={folderedit} />
        </ModalFooter>
      </Modal>

      {sharelink && (
        <ShareAssetSection
          openModal={sharelink}
          ParentId={
            selectedCount > 0
              ? images?.filter((item) => item?.isSelected === true).map((item) => item.damFileId)
              : [selectedDamFieldId]
          }
          toggleOpenModal={() => {
            setsharelink(!sharelink);
          }}
        />
      )}
            <div className="Print-main">
        {showData && (
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="mb-2">
              <p className="showingdata">
                Showing {assets?.files ? assets?.files?.length : assets?.length} assets
              </p>
            </div>
          </div>
        )}
        {showRenderActionButton && (
          <div className="d-flex justify-content-end ">
            <div className="d-flex align-items-center gap-2 mb-2">
              {collectionID ? '' : renderActionButtons()}
            </div>
          </div>
        )}

        {collectionID && (
          <div className="d-flex justify-content-end mb-4">
            <ButtonC
              size="lg"
              text="Move to Collection"
              click={() => {
                MoveToCollecction();
              }}
            />
          </div>
        )}

        {paginatedAssets.map((pageAssets, pageIndex) => (
          <div className="print-section" key={pageIndex}>
            <div
              className={`dis_grid asset_section_resposive_grid_${gridNumber}`}
              style={{ gap: '1rem' }}
            >
              {pageAssets.map((image, index) => (
                <div key={index}>
                  <ImageGridSecondVersion
                    Index={index}
                    Data={{
                      ...image,
                      ...(supportWebp
                        ? {
                          src: (image.thumnnailUrl ?? image?.fileUrl).replace('.png', '.avif'),
                          width: image.fileWidth,
                          height: image.fileHeight,
                          damFileId: image.assetId,
                          fileName: image?.assetName,
                          assetType: image?.assetType,
                          folderId: image?.folderId,
                          isSelected: image?.isSelected ?? false,
                        }
                        : {
                          src: image.thumnnailUrl ?? image?.fileUrl,
                          width: image.fileWidth,
                          height: image.fileHeight,
                          damFileId: image.assetId,
                          fileName: image?.assetName,
                          assetType: image?.assetType,
                          folderId: image?.folderId,
                          isSelected: image?.isSelected ?? false,
                        }),
                    }}
                    isSelected={image?.isSelected}
                    HandleSelect={(value) => {
                      if (value?.Key === 3) {
                        const _alldata = [
                          ...(selectedFolders ?? [])?.map((item) => ({
                            ...item,
                            identifactor: 1,
                            idx: item?.id,
                          })),
                          ...(selectedAssets ?? [])?.map((item) => ({
                            ...item,
                            identifactor: 2,
                            idx: item?.assetId,
                          })),
                        ];

                        const returnedValueData2 = selectRangeByUUID(
                          _alldata,
                          indexSelected,
                          value?.Image?.damFileId,
                          'idx',
                        );

                        const filteredFolder = returnedValueData2?.filter(
                          (item) => item?.identifactor === 1,
                        );
                        const filteredAsset = returnedValueData2?.filter(
                          (item) => item?.identifactor === 2,
                        );

                        dispatch(SelectedAssetData(filteredAsset));
                        dispatch(SetSelctedFoldersData(filteredFolder));
                        return;
                      }

                      if (value?.Key === 1) {
                        dispatch(
                          SetSelctedFoldersData(
                            selectedFolders?.map((item) => ({
                              ...item,
                              isSelected: false,
                            })),
                          ),
                        );
                      }

                      setImages((prev) => {
                        const updated = prev.map((item) => {
                          const isMatch = item?.damFileId === value?.Image?.damFileId;

                          if (value?.Key === 1) {
                            setPrevIndexSelected(value?.Image?.damFileId);
                            dispatch(SetInnerPrevSelected(value?.Image?.damFileId));
                            return isMatch
                              ? { ...item, isSelected: !item?.isSelected }
                              : { ...item, isSelected: false };
                          }

                          if (value?.Key === 2) {
                            setPrevIndexSelected(value?.Image?.damFileId);
                            dispatch(SetInnerPrevSelected(value?.Image?.damFileId));

                            return isMatch ? { ...item, isSelected: !item?.isSelected } : item;
                          }

                          if (value?.Key === 3) {
                            console.log('fourth');
                            // const returnedValueData = selectRangeByUUID(
                            //   images,
                            //   prevIndexSelected,
                            //   value?.Image?.damFileId,
                            // );
                            // return selectRangeByUUID(
                            //   images,
                            //   prevIndexSelected,
                            //   value?.Image?.damFileId,
                            // );
                          }

                          return item;
                        });

                        setSelectedCount(updated.filter((image) => image.isSelected).length);
                        dispatch(SelectedAssetData(updated));

                        return updated;
                      });
                    }}
                    EllipseActions={
                      <CommonSidePortal
                        activeId={activeId}
                        setActiveId={setActiveId}
                        portalId={index}
                        HandleEllipseClick={() => {
                          setImages((prev) => {
                            const updated = prev.map((item) => {
                              const isMatch = item?.damFileId === image?.damFileId;

                              return isMatch
                                ? { ...item, isSelected: true }
                                : { ...item, isSelected: false };
                            });

                            return updated;
                          });
                        }}
                        ViewSection={<CommonThreeDotSvg />}
                        Top={''}
                        OpenSection={
                          <div
                            className=""
                            style={{
                              top: '0px',
                              left: (index + 1) % 5 === 0 ? '-260px' : '0px',
                            }}
                          >
                            {showMoveFolder && (
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={() => {
                                  setMovetoModal(true);
                                  setSelectedDamFieldId(image.damFileId);
                                  setActiveId();
                                }}
                              >
                                {DAM_SVG.moveAssetSvgIcon}
                                <p className="list_cart">Move Folder</p>
                              </div>
                            )}
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => {
                                setSelectedDamFieldId(image.damFileId ?? image?.assetId);
                                setActiveId();
                                deletmodal();
                              }}
                            >
                              <img src={deleteicon} alt="deleteicon" />
                              <p className="list_cart">{DeleteButtonName}</p>
                            </div>
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => {
                                setActiveId();
                                setFolderId(image?.folderId);
                                settextvalue(image.assetName);
                                setAddToCollectionModal(!AddToCollectionModal);
                                setSelectedDamFieldId(image.damFileId);
                              }}
                            >
                              <img src={renameicon} alt="renameicon" />
                              <p className="list_cart">Rename</p>
                            </div>

                            {show ? (
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={() => {
                                  // collectiondataadd(image.damFileId);
                                  setSelectedDamFieldId(image?.damFileId);
                                  setActiveId();
                                  setOpenCollectionModal(true);
                                }}
                              >
                                <img src={addcomponent} alt="coomponenticon" />
                                <p className="list_cart">Add to Collection</p>
                              </div>
                            ) : (
                              ''
                            )}

                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => downloadImages(image.damFileId ?? image.assetId)}
                            >
                              <img src={download} alt="download" />
                              <p className="list_cart">Download</p>
                            </div>
                            {showCopyLing && (
                              <div
                                className="d-flex align-items-center gap-2 pointer"
                                onClick={() => Copylink(image.damFileId)}
                              >
                                <img src={copyurlicon} alt="copyurlicon" />
                                <p className="list_cart">Copy Link</p>
                              </div>
                            )}

                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => {
                                setActiveId();
                                dispatch(
                                  setOpenPopup({
                                    image,
                                    id: image.damFileId,
                                    assetType: 'file',
                                    fileName: image?.fileName,
                                  }),
                                );
                              }}
                            >
                              {' '}
                              <img src={shareicon} alt="componenticon" />{' '}
                              <p className="list_cart">Share</p>
                            </div>
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => {
                                setSelectedDamFieldId(image.damFileId ?? image?.assetId);
                                handleshowdata(image.damFileId ?? image?.assetId, 1);
                              }}
                            >
                              {' '}
                              {DAM_SVG.permissionSvg}
                              <p className="list_cart">Invite Outside Org.</p>
                            </div>
                            {shareshow ? (
                              <>
                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={() => handleshowdata(image.damFileId, 0)}
                                >
                                  <img src={shareicon} alt="componenticon" />
                                  <p className="list_cart">Public Link</p>
                                </div>

                                <div
                                  className="d-flex align-items-center gap-2 pointer"
                                  onClick={() => handleshowdata(image.damFileId, 1)}
                                >
                                  {' '}
                                  <img src={shareicon} alt="componenticon" />{' '}
                                  <p className="list_cart">Private Link</p>
                                </div>
                              </>
                            ) : (
                              ''
                            )}
                          </div>
                        }
                      />
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        ))}

      </div>
      <div
        className={`dis_grid no-print asset_section_resposive_grid_${gridNumber} `}
        style={{
          gap: '1rem',
        }}
      >
        {images?.map((image, index) => (
          <div key={index}>
            <ImageGridSecondVersion
              Index={index}
              Data={image}
              isSelected={image?.isSelected}
              HandleSelect={(value) => {
                if (value?.Key === 3) {
                  const returnedValueData = selectRangeByUUID(
                    images,
                    prevIndexSelected,
                    value?.Image?.damFileId,
                  );
                  dispatch(SelectedAssetData(returnedValueData));

                  setImages(returnedValueData);
                }

                setImages((prev) => {
                  const updated = prev.map((item) => {
                    const isMatch = item?.damFileId === value?.Image?.damFileId;

                    if (value?.Key === 1) {
                      setPrevIndexSelected(value?.Image?.damFileId);

                      return isMatch
                        ? { ...item, isSelected: !item?.isSelected }
                        : { ...item, isSelected: false };
                    }

                    if (value?.Key === 2) {
                      setPrevIndexSelected(value?.Image?.damFileId);
                      return isMatch ? { ...item, isSelected: !item?.isSelected } : item;
                    }

                    if (value?.Key === 3) {
                      console.log('fourth');
                      // const returnedValueData = selectRangeByUUID(
                      //   images,
                      //   prevIndexSelected,
                      //   value?.Image?.damFileId,
                      // );
                      // return selectRangeByUUID(
                      //   images,
                      //   prevIndexSelected,
                      //   value?.Image?.damFileId,
                      // );
                    }

                    return item;
                  });

                  setSelectedCount(updated.filter((image) => image.isSelected).length);
                  dispatch(SelectedAssetData(updated));

                  return updated;
                });
              }}
              EllipseActions={
                <CommonSidePortal
                  activeId={activeId}
                  setActiveId={setActiveId}
                  portalId={index}
                  HandleEllipseClick={() => {
                    setImages((prev) => {
                      const updated = prev.map((item) => {
                        const isMatch = item?.damFileId === image?.damFileId;

                        return isMatch
                          ? { ...item, isSelected: true }
                          : { ...item, isSelected: false };
                      });

                      return updated;
                    });
                  }}
                  ViewSection={<CommonThreeDotSvg />}
                  Top={''}
                  OpenSection={
                    <div
                      className=""
                      style={{
                        top: '0px',
                        left: (index + 1) % 5 === 0 ? '-260px' : '0px',
                      }}
                    >
                      {showMoveFolder && (
                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={() => {
                            setMovetoModal(true);
                            setSelectedDamFieldId(image.damFileId);
                            setActiveId();
                          }}
                        >
                          {DAM_SVG.moveAssetSvgIcon}
                          <p className="list_cart">Move Folder</p>
                        </div>
                      )}
                      <div
                        className="d-flex align-items-center gap-2 pointer"
                        onClick={() => {
                          setSelectedDamFieldId(image.damFileId);
                          setActiveId();
                          deletmodal();
                        }}
                      >
                        <img src={deleteicon} alt="deleteicon" />
                        <p className="list_cart">{DeleteButtonName}</p>
                      </div>
                      <div
                        className="d-flex align-items-center gap-2 pointer"
                        onClick={() => {
                          setActiveId();
                          setFolderId(image?.folderId);
                          settextvalue(image.fileName);
                          setAddToCollectionModal(!AddToCollectionModal);
                          setSelectedDamFieldId(image.damFileId);
                        }}
                      >
                        <img src={renameicon} alt="renameicon" />
                        <p className="list_cart">Rename</p>
                      </div>
                      <div
                        className="d-flex align-items-center gap-2 pointer"
                        onClick={() => {
                          setActiveId();
                          dispatch(
                            setOpenPopup({
                              id: image.damFileId,
                              assetType: 'file',
                              fileName: image?.fileName,
                            }),
                          );
                        }}
                      >
                        {' '}
                        {DAM_SVG.permissionSvg}
                        <p className="list_cart">Permission</p>
                      </div>
                      {show ? (
                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={() => {
                            // collectiondataadd(image.damFileId);
                            setSelectedDamFieldId(image?.damFileId);
                            setActiveId();
                            setOpenCollectionModal(true);
                          }}
                        >
                          <img src={addcomponent} alt="coomponenticon" />
                          <p className="list_cart">Add to Collection</p>
                        </div>
                      ) : (
                        ''
                      )}

                      <div
                        className="d-flex align-items-center gap-2 pointer"
                        onClick={() => downloadImages(image.damFileId)}
                      >
                        <img src={download} alt="download" />
                        <p className="list_cart">Download</p>
                      </div>
                      {showCopyLing && (
                        <div
                          className="d-flex align-items-center gap-2 pointer"
                          onClick={() => Copylink(image.damFileId)}
                        >
                          <img src={copyurlicon} alt="copyurlicon" />
                          <p className="list_cart">Copy Link</p>
                        </div>
                      )}

                      <div
                        className="d-flex align-items-center gap-2 pointer"
                        onClick={() => {
                          setSelectedDamFieldId(image.damFileId);
                          handleshowdata(image.damFileId, 1);
                        }}
                      >
                        {' '}
                        <img src={shareicon} alt="componenticon" />{' '}
                        <p className="list_cart">Share</p>
                      </div>
                      {shareshow ? (
                        <>
                          <div
                            className="d-flex align-items-center gap-2 pointer"
                            onClick={() => handleshowdata(image.damFileId, 0)}
                          >
                            <img src={shareicon} alt="componenticon" />
                            <p className="list_cart">Public Link</p>
                          </div>

                          <div
                            className="d-flex align-items-center gap-2 pointer"
                            onClick={() => handleshowdata(image.damFileId, 1)}
                          >
                            {' '}
                            <img src={shareicon} alt="componenticon" />{' '}
                            <p className="list_cart">Private Link</p>
                          </div>
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                  }
                />
              }
            />
          </div>
        ))}
      </div>

    </Fragment>
  );
};
